import APIError from '../APIError';

class EnrollmentError extends APIError {
  constructor(code, name, details = null) {
    super(code, name || 'EnrollmentError', details);
  }
}

export default EnrollmentError;
